module.exports = __webpack_public_path__ + "img/loader.f667dc34.svg";